module.exports = __webpack_public_path__ + "static/AzoSans-Bold-66c0cbf81269cab10c7ba39ed310f3a8.eot";